import React, { useState } from 'react';
import PortalButton from '../../components/Button';
import img1 from '../../images/reusable-nylon-bags.png';
import img2 from '../../images/new-provider-supply-pack.png';
import img3 from '../../images/premium-supply-kit.png';

const kitData = [
  {
    name: 'Reusable Nylon Bags (5 Packs)',
    price: '$19.60',
    img: img1,
  },
  {
    name: 'New Provider Supply Pack',
    price: '$39.99',
    img: img2,
  },
  {
    name: 'Premium Supply Kit',
    price: '$39.99',
    img: img3,
  },
];
function StarterKit() {
  return (
    <>
      <div className="space-y-2">
        {kitData.map((kit, index) => (
          <div className={'flex w-full p-3 ' + (index == 2 ? '' : 'border-b border-gray-300')} key={index}>
            <div className="w-6/12 p-5">
              <img src={kit.img} alt={kit.name} />
            </div>
            <div className="w-6/12 pt-6 md:pt-20">
              <div className="text-lg md:text-2xl text-statustext-100  font-semibold">{kit.name}</div>
              <div className="text-lg md:text-2xl text-portal-900  font-semibold">{kit.price}</div>
              <PortalButton variant="primary" text="Select Kit" classes="px-6 md:px-10 my-2 md:my-6" />
            </div>
          </div>
        ))}
      </div>
    </>
  );
}

export default StarterKit;
